/** @module application 薬キャリエージェントサイトで共通利用するスクリプト */
import '@/javascripts/ui/smartRollover';
import '@/javascripts/ui/header_fixed';
import '@/javascripts/ui/header_menu';
import '@/javascripts/ui/pc_sp_img_change';
import '@/javascripts/ui/footer_scroll_action';
import '@/javascripts/ui/pagetop';
import { mountHeaderFavoriteCount } from '@/javascripts/utils/mount_header_favorite_count';

// Sentryの初期化
import { initSentry } from '@/javascripts/utils/sentry_helper';
initSentry();

// ヘッダーのお気に入り件数バッジ(PC/SP)をマウントする
mountHeaderFavoriteCount();
